"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var bounceStyle_1 = __importDefault(require("./bounceStyle"));

exports.default = bounceStyle_1.default(function (_a) {
  var classes = _a.classes,
      style = _a.style,
      className = _a.className;
  return react_1.default.createElement("svg", {
    x: '0px',
    y: '0px',
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink',
    className: className,
    style: __assign({
      height: '1em'
    }, style),
    viewBox: '0 0 355.6 114.1'
  }, react_1.default.createElement("circle", {
    className: classes.first,
    cx: '62',
    cy: '56.2',
    r: '20.7'
  }), react_1.default.createElement("circle", {
    className: classes.second,
    cx: '182.2',
    cy: '56.2',
    r: '20.7'
  }), react_1.default.createElement("circle", {
    className: classes.third,
    cx: '302.3',
    cy: '56.2',
    r: '20.7'
  }));
});